import { BaseApi } from '@/main/baseApi';
import { DMS_MODULE as KARTOTEKA, PARTNER } from '@/modules/kartoteka/constants';
import { NAME as VOZIDLO } from '@/modules/kartoteka/vozidlo/constants';
import { NAME as ZAKAZKA } from '@/modules/servis/zakazka/constants';

import { DependentTableNames, DMS_MODULE, MERGE_VOZIDLO, MERGE_ZAKAZNIK, NAME, PHOTO_LIST, PENDING_JOB_LIST } from './constants';

class CheckinApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async propojSeZakazkou(checkinId: number, ozakazkaId: number): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/PropojSeZakazkou?checkinId=${checkinId}&ozakazkaId=${ozakazkaId}`);
	}

	async checkInChange(filter: any) {
		return this.post(`/${DMS_MODULE}/${ZAKAZKA}/CheckinChange`, { ...filter });
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case MERGE_ZAKAZNIK:
				return `/${KARTOTEKA}/${PARTNER}/MergeSchema`;
			case MERGE_VOZIDLO:
				return `/${KARTOTEKA}/${VOZIDLO}/MergeSchema`;
			case PHOTO_LIST:
				return `/${DMS_MODULE}/${NAME}/PhotosListSchema`;
			case PENDING_JOB_LIST:
				return `/${KARTOTEKA}/${VOZIDLO}/ZavadaSchema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case MERGE_ZAKAZNIK:
				return `/${KARTOTEKA}/${PARTNER}/MergeRows`;
			case MERGE_VOZIDLO:
				return `/${KARTOTEKA}/${VOZIDLO}/MergeRows`;
			case PHOTO_LIST:
				return `/${DMS_MODULE}/${NAME}/GetPhotosList`;
			case PENDING_JOB_LIST:
				return `/${KARTOTEKA}/${VOZIDLO}/ZavadaRows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	getCheckinReportPdf(PchiObchodnikNr: string, IsNahlad: boolean, MiddlewareCheckinId:number) {
		return this.fetchPdf(`${this.apiPath}Reports/getCheckinReportPdf`, { PchiObchodnikNr, IsNahlad, MiddlewareCheckinId });
	}

	getPhoto(checkInId: number, dealerNr: string, photoIndex: number, photoType: number) {
		return this.fetchBlobs(`/${DMS_MODULE}/${NAME}/GetCheckInPhoto`, { checkInId, dealerNr, photoIndex, photoType });
	}

	async isWatchlistedVIN(VozidloVin: any) {
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA}/Iswatchlistedcar?VozidloVin=${VozidloVin}`);
	}

	async compareWatchlistDTO(Vozidlo: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/GetAdditionalCheckinServices`, Vozidlo);
	}

	getRepeatRepairRevisit(Vozidloidi: number, odometer: number): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRepeatRepairRevisit?VehicleId=${Vozidloidi}&odom=${odometer}`);
	}

	async vozidloChange(zakazka: any) {
		return this.post('/Servis/Zakazka/ZmenaVozidlo', zakazka);
	}
}

export const apiProvider = new CheckinApi();
